<mat-form-field class="location-input" matAutocompleteOrigin #locationAutocompleteOrigin="matAutocompleteOrigin">
  <mat-label>{{ fieldConfig.label }}</mat-label>
  <input
    type="text"
    matInput
    [attr.aria-label]="fieldConfig.ariaLabel"
    [formControl]="control"
    autocomplete="no"
    [matAutocomplete]="locationAutocomplete"
    [matAutocompleteConnectedTo]="locationAutocompleteOrigin"
    [class.location-input--error]="(emptyDataError$ | async) === true"
  />
  <mat-hint *ngIf="!fieldConfig.required" align="start">Optionnel</mat-hint>

  <mat-autocomplete
    autoActiveFirstOption
    [displayWith]="displayCity"
    #locationAutocomplete="matAutocomplete"
    (closed)="doClosed()"
    class="dropdown-panel dropdown-panel--location"
  >
    <mat-option *ngFor="let city of cities$ | async; trackBy: trackByCity" [value]="city"
      >{{ city?.codePostal }} - {{ city?.libelle }}</mat-option
    >

    <ng-container *ngIf="(emptyDataError$ | async) === true">
      <mat-optgroup label="Aucune suggestion ne correspond à votre saisie." class="mat-optgroup--error">
        <mat-option class="mat-option--error"> {{ fieldConfig.emptyData }} </mat-option>
      </mat-optgroup>
    </ng-container>
  </mat-autocomplete>
  <mat-error *ngIf="control.errors?.required">{{ fieldConfig.error }}</mat-error>
  <mat-error *ngIf="control.errors?.cityRequired">{{ fieldConfig.invalid }}</mat-error>
</mat-form-field>
